import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    setTimeout(() => {
      navigator.serviceWorker.register('/sw.js')
        .then((reg) => {
          console.log('Service worker registered after delay.', reg);
        })
        .catch((err) => {
          console.warn('Service worker registration failed:', err);
        });
    }, 2000); // 2 second delay
  });
}


//reportWebVitals();
